<template>
    <el-row class="warp">
    <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="filters" ref="searchForm">
          <el-form-item>
            <el-input v-model="filters.typeName" placeholder="设备类型名称" style="min-width: 340px;"
                      @keyup.enter.native="handleSearch"></el-input>
          </el-form-item>
           <el-form-item>
            <el-input v-model="filters.typeCode" placeholder="设备类型编码" style="min-width: 340px;"
                      @keyup.enter.native="handleSearch"></el-input>
          </el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button type="primary" @click="searchReset">重置</el-button>
          <el-button type="primary" @click="showAddDialog(0)">添加根类型</el-button>
        </el-form>
      </el-col>

      <!--列表-->
      <el-table :data="dictList" highlight-current-row border
        row-key="dictId"
        :tree-props="{children: 'child', hasChildren: 'hasChildren'}"
      >
        <el-table-column prop="typeName" label="设备类型名称" align="left" fixed="left" ></el-table-column>
        <el-table-column prop="typeCode" label="设备类型编码" align="center" width="200" ></el-table-column>
        <el-table-column prop="createDate" label="创建时间"  align="center" width="160" ></el-table-column>
        <el-table-column prop="createUser" label="创建人"  align="center" width="160" ></el-table-column>
       
        <el-table-column label="操作" fixed="right" align="center" width="220">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="showAddDialog(scope.row.dictId)">增加</el-button>
            <el-button size="mini" type="primary" @click="showEditDialog(scope.$index,scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="remove(scope.$index,scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 添加、修改界面 -->
      <el-dialog :title="form.title" :visible.sync="form.visible" :close-on-click-modal="false"  top="5vh" :append-to-body="true">
        <el-form :model="form.data" label-width="80px" :rules="form.rules" ref="formref" >
          <table style="width: 100%;">
            <tr>
                <td>
                    <el-form-item label="设备类型名称" label-width="120px" prop="name" class="clear-margin-bottom">
                    <el-input v-model="form.data.typeName" placeholder="设备类型名称" auto-complete="off"></el-input>
                    </el-form-item>
                </td>
                <td>
                    <el-form-item label="设备类型编码" label-width="120px" prop="code">
                    <el-input v-model="form.data.typeCode" placeholder="设备类型编码" auto-complete="off"></el-input>
                    </el-form-item>
                </td>
            </tr>
             <tr>
              <td colspan="2">
                <el-form-item label="备注" label-width="120px">
                  <el-input type="textarea" :row="4" v-model="form.data.remark"  placeholder="备注" auto-complete="off"></el-input>
                </el-form-item>
              </td>
            </tr>
          </table>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="form.visible=false"  style="margin-top:10px;">取消</el-button>
          <el-button type="primary" @click.native="form.submit" :loading="loading"  style="margin-top:10px;">提交</el-button>
        </div>
      </el-dialog>
    </el-col>
  </el-row>
</template>

<script>
  import API from "../../api/third/dict";
  export default {
     props:{
         platformId:{ type: String, default: null},
         openflg:{type:Number,default:-1}
     },
    data() {
      return {
        loading:false,
        dictList: [],
        total: 0,
        page: 1,
        limit: 10,
        //条件
        filters:{
          typeName:undefined,
          typeCode:undefined
        },
        //编辑窗体  
        form:{
          loading:false, //加载动画
          title:'', //编辑窗体名称
          visible:false, //窗体是否显示
          rules:{//验证逻辑
            typeName: [
              {required: true, message: "请输入类型名称", trigger:['blur','change']},
              { min: 1,max:100,message: '长度1-100个字符', trigger: ['blur','change']}
            ],
            typeCode:[ {required: true, message: "请输入类型编码", trigger:['blur','change']},]
          },   
          data:{},
          //定义form的提交按钮
          submit:function(){},
        },
        event:{
            title:'新增事件', //接口
            visible:false, //窗体是否显示
            dataList:[],
            selectData:function(val){}
        }
      };
    },
    watch:{
    },
    methods:{
      //重置
      searchReset:function(){
        this.filters={};
        this.$refs.searchForm.resetFields();
      },
      //获取平台数据
      search: function () {
        let that = this;
        let params = {
          page: that.page,
          limit: that.limit,
          platformId: that.platformId,
          typeName: that.filters.typeName? that.filters.typeName : undefined,
          typeCode: that.filters.typeCode ? that.filters.typeCode : undefined
        };

        that.loading = true;
        API.getList(params)
          .then(
            function (result) {
              that.loading = false;
              console.log(result)
              if (result && result.code == 200) {
                that.total = result.data.total;
                that.dictList = result.data;
              }
            },
            function (err) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function (error) {
            that.loading = false;
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      },
      handleSizeChange(val) {
        this.limit = val;
        this.search();
      },
      handleCurrentChange(val) {
        this.page = val;
        this.search();
      },
      handleSearch() {
        this.total = 0;
        this.page = 1;
        this.search();
      },
      //添加
      showAddDialog(pid){
          console.log(pid);
        let that =this;
        that.form.title="新增设备类型信息";
        that.form.data={};
        that.event.dataList =[];
        that.form.visible=true;
        if(that.$refs.formref){
          that.$refs.formref.resetFields();
        }
        //提交保存
        that.form.submit=function(){
          that.$refs.formref.validate(valid => {
            if(valid){
              that.form.data.platformId = that.platformId;
              that.form.data.pid = pid;
              API.insert(that.form.data)
                .then(
                    function (result) {
                      that.loading = false;
                      if (result && result.code == 200) {
                        that.$message.success({
                          showClose: true,
                          message: "新增成功",
                          duration: 2000
                        });
                        that.form.visible = false;
                        that.search();
                      }
                      else{
                          that.$message.error({
                          showClose: true,
                          message: result.msg,
                          duration: 2000
                        });
                      }
                    },
                    function (err) {
                    that.loading = false;
                    that.$message.error({
                        showClose: true,
                        message: err.toString(),
                        duration: 2000
                    });
                    }
                )
                .catch(function (error) {
                    that.loading = false;
                    console.log(error);
                    that.$message.error({
                    showClose: true,
                    message: "请求出现异常",
                    duration: 2000
                    });
                });
            }
          })
          
        }
      },
      //编辑
      showEditDialog(index,row){
        let that =this;
        that.form.title="编辑设备类型信息";
        that.form.data={};
         that.event.dataList =[];
        that.form.visible=true;
        if(that.$refs.formref){
          that.$refs.formref.resetFields();
        }
        //加载详情数据
        that.form.visible=true;
        that.loading = true;
        API.detail(row.dictId)
                .then(
                    function (result) {
                      if (result && result.code == 200) {
                        that.loading=false;
                        console.log(result.data);
                        //赋值
                        that.form.data=result.data;
                        that.event.dataList = result.data.events;
                      }
                      else{
                          that.$message.error({
                          showClose: true,
                          message: result.msg,
                          duration: 2000
                        });
                      }
                    },
                    function (err) {
                    that.loading = false;
                    that.$message.error({
                        showClose: true,
                        message: err.toString(),
                        duration: 2000
                    });
                    }
                )
                .catch(function (error) {
                    that.loading = false;
                    that.$message.error({
                    showClose: true,
                    message: "请求出现异常",
                    duration: 2000
                    });
                });
      
        //提交
        that.form.submit=function(){
          that.$refs.formref.validate(valid => {
                if(valid){
                  API.update(that.form.data)
                    .then(
                        function (result) {
                          that.loading = false;
                          if (result && result.code == 200) {
                            that.$message.success({
                              showClose: true,
                              message: "修改成功",
                              duration: 2000
                            });
                            that.form.visible = false;
                            that.search();
                          }
                          else{
                              that.$message.error({
                              showClose: true,
                              message: result.msg,
                              duration: 2000
                            });
                          }
                        },
                        function (err) {
                        that.loading = false;
                        that.$message.error({
                            showClose: true,
                            message: err.toString(),
                            duration: 2000
                        });
                        }
                    )
                    .catch(function (error) {
                        that.loading = false;
                        console.log(error);
                        that.$message.error({
                        showClose: true,
                        message: "请求出现异常",
                        duration: 2000
                        });
                    });
                }
              })
        }
      },
      //删除
      remove(index,row){
        let that = this;
        this.$confirm("确认删除该记录吗?", "提示", {type: "warning"})
          .then(() => {
            that.loading = true;
            API.delete(row.interId)
              .then(
                function (result) {
                  that.loading = false;
                  if (result && result.code === 200) {
                    that.$message.success({
                      showClose: true,
                      message: "删除成功",
                      duration: 1500
                    });
                    that.search();
                  }else{
                    that.$message.error({
                      showClose: true,
                      message: result.msg,
                      duration: 1500
                    });
                  }
                },
                function (err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function (error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {
          });
      },
      //删除事件
      removeEvent:function(index,row){
          let that = this;
          that.event.dataList.splice(index,1);
      },
      //打开选择事件窗口
      showEventDialog(){
          let that = this;
          this.event.visible = true;
          this.event.selectData= function(val){
            that.event.visible = false;
            that.event.dataList = val;
          }
          this.event.openflg = (this.event.openflg ==undefined ? 0 : this.event.openflg +1);
      }
    },
    mounted() {
       this.handleSearch();
        this.event.dataList=[];
        this.interList=[];
    },
    watch: {
        openflg(){
            this.handleSearch();
            this.event.dataList=[];
            this.interList=[];
        }
  },
  };
</script>



// WEBPACK FOOTER //
// dict.vue?2ce3661a